import React, { useEffect, useRef, useState } from "react";
import "./widgets.scss";
import Layout from "../../components/global/layout";
import SelectDropdown from "../../components/common/SelectDropdown";
import { TbMessageChatbot } from "react-icons/tb";
import ApiClient from "../../methods/api/apiClient";
import environment from "../../environment";
import loader from "../../methods/loader";
import { useDispatch, useSelector } from "react-redux";
import { Form, useNavigate } from "react-router-dom";
import methodModel from "../../methods/methods";
import ChatbotApiClient from "../../methods/api/chatbotapiClient";
import { FiUpload, FiX } from "react-icons/fi";
import { FaThumbsDown } from "react-icons/fa";
import axios from "axios";
import { toast } from "react-toastify";
import { store_chatbot_data } from "../../actions/chatbot";
import _ from 'lodash'; 
import Checkbox from "../../components/checkbox/checkbox";
import { ChatbotContext } from "../ChatBot/TabContextProvider";
import { encryptId } from "../../libs/SecurityHandler";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { IoChatbubbleEllipses, IoChevronDown, IoChevronForwardOutline, IoChevronUp, IoColorPaletteOutline } from "react-icons/io5";
import { RxText } from "react-icons/rx";
import { LuImage } from "react-icons/lu";
import { GrChannel } from "react-icons/gr";

const Widget = () => {
  const history = useNavigate();
  const { fetchData } = React.useContext(ChatbotContext);
  const [ChatOptionSelected, setChatOptionSelected] = useState(false);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [chatbotData, setChatbotData] = useState();
  const [chatbotAppearanceData, setChatbotAppearanceData] = useState({
    chatbot_title: null,
    bot_message_background: "",
    bot_message_color: "#FFFFFF",
    user_message_background: "#e4e4e7",
    user_message_color: "#0a0a0a",
    chatbot_background_color: "#ffffff",
    bot_message_color: "#ffffff",
    bot_message_background: "#6900d1",
    top_bar_background: "#e0e0e0",
    top_bar_textcolor: "#121111",
  });
  const [chatbotImage, setChatbotImage] = useState(null);
  const [chatbotLogo, setChatbotLogo] = useState(null);
  const chatbotLogoRef = useRef();
  const chatbotImageRef = useRef();
  const chatbotLogoViewRef = useRef();
  const chatbotImageViewRef = useRef();
  const [soundSize, setSoundSize] = useState("");
  const [IsCopied, setIsCopied] = useState(false);
  const [WidthChanger, setWidthChanger] = useState(false);
  const [HieghtChanger, setHeightChanger] = useState(false);
  const [form, setForm] = useState({
    buttonStyle: "",
    colorTheme: "#5d62df",
    size: "",
    radius: 0,
    logo: "",
    iconSize: 64,
    show_disclaimer: false,
    disclaimer: 'Our Chatbot aims to be helpful, but please double-check important details.',
    position: "right",
    xAxis: 0,
    yAxis: 0,
    channels: [],
    iconText: "",
    title: "",
    show_initial_message: true,
    description: "",
    label: "",
    menuSize: "",
    menuWidth: 200,
    menuIconStyle: "",
    menuBorder: "",
    menuBorderColor: "#5d62df",
    menuIconColor: "#5d62df",
    menuBackground: "#ffffff",
    menuTitleColor: "#000000",
    hoverItemBg: "#5d62df",
    hoverItemTitleColor: "#000000",
    menuShadowSize: 0,
    menuShadowOpacity: 0,
    chat_bubble_color: "#412092",
    chat_bubble_show: true,
    chat_bubble_logo: false,
    showHeader: false,
    bubbleHeight: 60,
    chat_bubble_icon_color: "#ffffff",
    bubbleWidth: 60,
    live_button_text_color: '#D0BAFD',
    live_button_background: '#F2EBFE',
    sound_notification_url: 'https://app.dazhboards.com/assets/notification.mp3',
    sound_notification_enabled: false,
    sound_file_name: null,

  });

  const location = window.location.origin;

  const script = `<script>
window.iknow = {
id:'${(user?.mainUserId)
    }',
}
</script>
<script
id='iknow-widget' 
src='${location}/assets/js/test.js'>
defer 
</script>
`;

  const copyScript = () => {
    navigator.clipboard.writeText(script).then((res) => {
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    });
  };

 

  const handleChange = (e,key) => {
    const { name, value } = e.target;
    setChatbotAppearanceData({
      ...chatbotAppearanceData,
      [name]: value,
    });
  };
  const handleFileChange = (e,key) => {
    const { name, files } = e.target;
    const file = files[0];

    if (!file) return;

    // ✅ Check file size (max 500 KB)
    const maxSize = 500 * 1024;
    if (file.size > maxSize) {
      swal({ text: "Logo size must be less than 500KB", icon: 'error', className: 'smallModal' });
      return

    }

    // ✅ Check file type
    const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
    if (!validTypes.includes(file.type)) {
      swal({ text: 'Please upload a valid image (JPG, JPEG, PNG, WEBP)', className: 'smallModal', icon: 'error' })
      return
    }
    loader(true);
    ApiClient.postFormData("upload/image", { file }).then(
      (res) => {
        if (res.fileName) {
          setChatbotAppearanceData((prev) => ({ ...prev, [key]: res.fileName }));
        }
        loader(false);
      }
    );

    
  };


  const handleChatbotSubmit = async (event, type = "", loading = true) => {
    if (event) {
      event.preventDefault();
    }
    if (!urlAllow("editchatbot")) {
      return;
    }
    if (!chatbotAppearanceData?.id) {
      return
    }
    if (loading) {
      loader(true);
    }
    const formDataToSend = new FormData();
    if (chatbotImage && chatbotImage[0]) {
      formDataToSend.append("fileImage", chatbotImage[0]);
    }
    if (chatbotLogo && chatbotLogo[0]) {
      formDataToSend.append("fileLogo", chatbotLogo[0]);
    }
    Object.keys(chatbotAppearanceData).forEach((key) => {
      if (key == "font_size") {
        return;
      }
      formDataToSend.append(key, chatbotAppearanceData[key]);
    });
    await axios
      .post(
        environment.chatbot_api + "api/chatbot-appearance-save/",
        formDataToSend
      )
      .then(function (res) {
        fetchData()
        const response = res.data;
        fetchData();
        if (response.success) {
          if (event) {
            if (loading) {
              setChatbotAppearanceData(response.data);
              setTimeout(() => {
                if (type != "copy") {
                  swal({
                    text: "Details updated successfully",
                    icon: "success",
                    className: "smallmodal",
                  });
                }
              }, 200);
            }
          }
        } else {
          toast.error(response.data);
        }
        loader(false);
      });
  };

  const onSubmit = (e) => {
    if (e) {
      e?.preventDefault();
    }
    if (!urlAllow("editchatbot")) {
      return;
    }
    if (e) {
      loader(true);
    }
    ApiClient.post("widget-setting/update", {
      setting: {...form,chatboData:chatbotAppearanceData},
      user_id: user?.supplier_id?._id || user?.supplier_id?.id || user?._id,
      type: "chat",
      script: script,
    }).then((res) => {
      if (res.success) {
        if (e) {
          getData(false);
        }
      }
      loader(false);
    });
  };


  useEffect(() => {
    getData();
  }, []);

  const getData = (formset = true) => {
    const response = (res) => {
      if (res.success) {
        let data = res.data.setting;
               const Chatdata = {
        ...data?.chatboData,
        chatbot_title: data?.chatboData?.chatbot_title,
        bot_message_background: data?.chatboData?.bot_message_background,
        bot_message_color:data?.chatboData?.bot_message_color || "#FFFFFF",
        user_message_background:data?.chatboData?.user_message_background == "#6956E528"? "#e4e4e7": data?.chatboData?.user_message_background,
        user_message_color:data?.chatboData?.user_message_color == "#6956E5FF"? "#6956E5": data?.chatboData?.user_message_color,
        chatbot_background_color:data?.chatboData?.chatbot_background_color || "#ffffff",
        bot_message_color:data?.chatboData?.bot_message_color || "#ffffff",
        bot_message_background:data?.chatboData?.bot_message_background || "#6900d1",
        top_bar_background:data?.chatboData?.top_bar_background || "#e0e0e0",
        top_bar_textcolor:data?.chatboData?.top_bar_textcolor || "#121111",
      }
        if (formset)
       
setChatbotAppearanceData(Chatdata);
          setForm({
            ...form,
            ...data,
            chatbotBorderColor: data?.chatbotBorderColor || "#115B9D",
            sendBtnBg: data?.sendBtnBg || "#115B9D",
            chat_bubble_show: true,
            logo: data?.logo || user?.logo,
            live_button_text_color: data?.live_button_text_color || '#D0BAFD',
            live_button_background: data?.live_button_background || '#F2EBFE',
            sound_notification_url: data?.sound_notification_url || 'https://app.dazhboards.com/assets/notification.mp3',
            sound_notification_enabled: data?.sound_notification_enabled || false,
            sound_file_name: data?.sound_file_name || null,
            show_disclaimer: data?.show_disclaimer ?? false,
            disclaimer: data?.disclaimer || 'Our Chatbot aims to be helpful, but please double-check important details.'

          });
      }
    };
    ApiClient.getAll({
      url: "widget-setting/detail",
      params: {
        id:
          user?.mainUserId,
        type: "chat",
      },
      response: response,
    });
  };

  const buttonStyles = [
    { id: "regular", name: "Regular" },
    { id: "no-background", name: "No-background" },
  ];

  const buttonSizes = [
    { id: "huge", name: "Huge" },
    { id: "large", name: "Large" },
    { id: "medium", name: "Medium" },
    { id: "small", name: "Small" },
  ];

  const positions = [
    { id: "left", name: "Left" },
    { id: "right", name: "Right" },
  ];

  const menuSizes = [
    { id: "large", name: "Large" },
    { id: "medium", name: "Medium" },
    { id: "small", name: "Small" },
  ];

  const menuIconStyles = [
    { id: "filled", name: "Filled" },
    { id: "outlined", name: "Outlined" },
    { id: "no-background", name: "No-background" },
  ];

  const menuBorders = [
    { id: "solid", name: "Solid" },
    { id: "dashed", name: "Dashed" },
  ];

  const urlAllow = (url) => {
    let permissions =
      user?.subRole &&
      user?.subRole?.permissions &&
      user?.subRole?.permissions[0];
    let arr = url?.split(",");
    let value = false;
    arr.map((itm) => {
      if (permissions?.[itm]) value = true;
    });
    if (user?.subRole?.id || user?.subRole?._id) {
      return value;
    } else {
      return true;
    }
  };
  const LogoUploader = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // ✅ Check file size (max 500 KB)
    const maxSize = 500 * 1024;
    if (file.size > maxSize) {
      swal({ text: "Logo size must be less than 500KB", icon: 'error', className: 'smallModal' });
      return;
    }

    // ✅ Check file type
    const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
    if (!validTypes.includes(file.type)) {
      swal({ text: "Please upload a valid image (JPG, JPEG, PNG, WEBP)", icon: 'error', className: 'smallModal' });
      return;
    }

    loader(true);
    ApiClient.postFormData("upload/image", { file }).then(
      (res) => {
        if (res.fileName) {
          setForm((prev) => ({ ...prev, logo: res.fileName }));
        }
        loader(false);
      }
    );
  };

  const saveRef = useRef(null);
  const PositionOptions = [
    {
      name: "Bottom Right",
      id: "Bottom Right",
      xAxis: 0,
      yAxis: 0,
      position: "right",
    },
    {
      name: "Bottom Left",
      id: "Bottom Left",
      xAxis: 0,
      yAxis: 0,
      position: "left",
    },
  ];

  const ChatBubbleSVG = ({ width = 40, height = 40, color = "white", className = "" }) => (
   <TbMessageChatbot className="sm:text-[24px] text-[22px] "/>
  );


  const [ChatChannels, setChatChannels] = useState([
    { id: 'whatsapp', name: 'Whatsapp' },
    { id: 'facebook', name: 'Facebook' },
    { id: 'instagram', name: 'Instagram' },
    // {id:'livechat',name:'LiveChat'}
  ])


  const ChannelValueCHanger = (e, key) => {
    const data = form?.channels;
    const findedINdex = data?.findIndex((_itm) => _itm?.platform == key);
    data[findedINdex]['url'] = e.target.value;
    setForm(prev => ({ ...prev, channels: data }))
  }
  const [SelectedPlatform, setSelectedPlatform] = useState('livechat');
  const PlatformClickHandler = (platform) => {
    const UrlFinder = form?.channels?.find((_itm) => _itm?.platform == platform)?.url || ''
    if (platform == 'whatsapp' || platform == 'facebook' || platform == 'instagram') {
      window.open(UrlFinder, '_blank')
    } else {
      setSelectedPlatform(platform)
    }
  }
  return (
    <>
      {/* <Layout> */}
      <div className="i w-full border rounded-2xl bg-white p-5 lg:p-8">
        <div className="max-w-[1420px]" ref={saveRef}>
          <div
            className={`${urlAllow("editchatbot") ? "" : "pointer-events-none"}`}
          >
            <div className="grid grid-cols-12 gap-x-6">
              <div className="col-span-12 lg:col-span-7 xl:col-span-7 ">
                <div className="mb-5">
                  <h4 className="text-2xl font-semibold text-[#3C3E49] mb-1">
                    Widget Settings
                  </h4>
                  <p className="text-gray-600">Customize your chatbot widget to match your brand</p>
                </div>
                <form onSubmit={e => { onSubmit(e); handleChatbotSubmit(e) }} className="space-y-6">
                  <Disclosure defaultOpen>
                    {({ open }) => (
                      <div className="border border-gray-200 rounded-2xl overflow-hidden bg-white">
                        <DisclosureButton className="w-full px-5 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors">
                          <div className="flex items-center gap-3">
                            <div className="size-10 rounded-xl bg-[#115B9D17] flex items-center justify-center flex-shrink-0">
                              <MdOutlineRemoveRedEye className="text-md text-[#115B9D]" />
                            </div>
                            <div className="text-left">
                              <h3 className="text-gray-900">Appearance</h3>
                              <p className="text-sm text-gray-500">Configure widget size and position</p>
                            </div>
                          </div>
                          {open ? <IoChevronUp className="text-lg text-[#99a1af]" /> : <IoChevronDown className="text-lg text-[#99a1af]" />}
                          {/* <IoChevronForwardOutline className="text-lg text-[#99a1af]" /> */}
                        </DisclosureButton>

                        <DisclosurePanel className="border-t border-gray-200 bg-gray-50 space-y-5 px-5 py-5">
                          <>

                            <div className="bg-white rounded-xl p-4">
                              <p className="text-sm font-semibold text-[#3C3E49] mb-3">Widget Position</p>

                              <div className="grid max-[400px]:grid-cols-1 grid-cols-2 gap-3 sm:gap-5">
                                {PositionOptions?.map((_itm) => {
                                  let check = _itm?.position == form?.position;
                                  const Clickable = (value) => {
                                    let FindedData = PositionOptions?.find(
                                      (_data) => _data?.id == value
                                    );
                                    if (FindedData) {
                                      setForm({ ...form, ...FindedData });
                                    }
                                  }
                                  return check ? (
                                    <div onClick={() => Clickable(_itm?.id)} className={`text-center font-semibold px-4 py-3 rounded-xl text-xs sm:text-sm transition-all bg-[#115B9D] border border-gray-300 text-white hover:border-[#115B9D] cursor-pointer`}>
                                      {_itm?.name}
                                    </div>) : (
                                    <div onClick={() => Clickable(_itm?.id)} className="text-center font-semibold px-4 py-3 rounded-xl text-xs sm:text-sm transition-all bg-white border border-gray-300 text-gray-700 hover:border-[#115B9D] cursor-pointer">
                                      {_itm?.name}
                                    </div>
                                  )
                                }
                                )}

                              </div>
                            </div>

                            <div className="bg-white rounded-xl p-4">
                              <p className="text-sm font-semibold text-[#3C3E49] mb-3">Margins</p>

                              <div className="space-y-5">

                                {/* <div>
                              <label className="inline-block mb-1 text-sm">
                                Icon Position
                              </label>
                              <SelectDropdown
                                id="statusDropdown"
                                displayValue="name"
                                className="w-full"
                                showPlaceHolder={false}
                                placeholder="Select Position"
                                intialValue={
                                  PositionOptions?.find(
                                    (_data) => _data?.position == form?.position
                                  )?.id || ""
                                }
                                result={(e) => {
                                  let FindedData = PositionOptions?.find(
                                    (_data) => _data?.id == e?.value
                                  );
                                  if (FindedData) {
                                    setForm({ ...form, ...FindedData });
                                  }
                                }}
                                options={PositionOptions}
                              />
                            </div> */}
                                <div>
                                  <label className="flex inline-block mb-1 text-sm">
                                    Icon Horizontal Settings{" "}
                                    <span className="ml-auto">{form.xAxis}px</span>
                                  </label>
                                  <input
                                    type="range"
                                    max="200"
                                    min="0"
                                    value={form.xAxis}
                                    onChange={(e) =>
                                      setForm({ ...form, xAxis: e.target.value })
                                    }
                                    className="w-full h-2 bg-gray-200 appearance-none cursor-pointer slider rounded-large dark:bg-gray-700"
                                  />
                                </div>
                                <div>
                                  <label className="flex inline-block mb-1 text-sm">
                                    Icon Vertical Settings
                                    <span className="ml-auto">{form.yAxis}px</span>
                                  </label>
                                  <input
                                    type="range"
                                    max="200"
                                    min="0"
                                    value={form.yAxis}
                                    onChange={(e) =>
                                      setForm({ ...form, yAxis: e.target.value })
                                    }
                                    className="w-full h-2 bg-gray-200 appearance-none cursor-pointer slider rounded-large dark:bg-gray-700"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="bg-white rounded-xl p-4">
                              <p className="text-sm font-semibold text-[#3C3E49] mb-3">Bubble Size</p>
                              <div className="space-y-5">
                                <div className="grid grid-cols-2 gap-3 sm:gap-5">
                                  <div className="">
                                    <label className="inline-block pb-[5px] text-sm">Width</label>
                                    <div className="relative flex items-center border border-[#E7E7E8] rounded-lg overflow-hidden shadow-box">
                                      <input
                                        value={form?.bubbleWidth}
                                        onChange={(e) => {
                                          let Keys = { bubbleWidth: e.target.value };
                                          if (!WidthChanger) {
                                            Keys = {
                                              bubbleWidth: e.target.value,
                                              bubbleHeight: e.target.value,
                                            };
                                          }
                                          setHeightChanger(true);
                                          setForm((prev) => ({ ...prev, ...Keys }));
                                        }}
                                        type="number"
                                        className="px-2 py-3 pr-10 placeholder:text-sm text-sm text-[#2B2B2B] w-full outline-none"
                                        placeholder="Width"
                                      />
                                      <span className="absolute right-3 text-[#2B2B2B] text-sm border-l border-gray-100 pl-2">
                                        px
                                      </span>
                                    </div>
                                  </div>
                                  <div className="">
                                    <label className="inline-block pb-[5px] text-sm">Height</label>
                                    <div className="relative flex items-center border border-[#E7E7E8] rounded-lg overflow-hidden shadow-box">
                                      <input
                                        value={form?.bubbleHeight}
                                        onChange={(e) => {
                                          let Keys = { bubbleHeight: e.target.value };
                                          if (!HieghtChanger) {
                                            Keys = {
                                              bubbleWidth: e.target.value,
                                              bubbleHeight: e.target.value,
                                            };
                                          }
                                          setWidthChanger(true);
                                          setForm((prev) => ({ ...prev, ...Keys }));
                                        }}
                                        type="number"
                                        className="px-3 py-3 pr-10 placeholder:text-sm text-sm text-[#2B2B2B] w-full outline-none"
                                        placeholder="Height"
                                      />
                                      <span className="absolute right-3 text-[#2B2B2B] text-sm border-l border-gray-100 pl-2">
                                        px
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                {/* {form?.chat_bubble_show && (
                                <div className="flex items-center gap-1">
                                  <input
                                    onChange={(e) =>
                                      setForm((prev) => ({
                                        ...prev,
                                        chat_bubble_logo: e.target.checked,
                                      }))
                                    }
                                    checked={form?.chat_bubble_logo}
                                    type="checkbox"
                                    className="h-4 w-4 cursor-pointer bg-white shrink-0 rounded-sm border border-gray-300 !text-[#115B9D]"
                                  />
                                  <label className="inline-block text-sm">
                                    Do you want to show Logo on Chat Bubble
                                  </label>
                                </div>
                              )} */}
                              </div>
                            </div>
                          </>
                        </DisclosurePanel>
                      </div>)}
                  </Disclosure>


                  <Disclosure>
                    {({ open }) => (<div className="border border-gray-200 rounded-2xl overflow-hidden bg-white">
                      <DisclosureButton className="w-full px-5 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors">
                        <div className="flex items-center gap-3">
                          <div className="size-10 rounded-xl bg-[#115B9D17] flex items-center justify-center flex-shrink-0">
                            <RxText className="text-md text-[#115B9D]" />
                          </div>
                          <div className="text-left">
                            <h3 className="text-gray-900">Chat Interface Text</h3>
                            <p className="text-sm text-gray-500">Customize chatbot messages</p>
                          </div>
                        </div>
                        {open ? <IoChevronUp className="text-lg text-[#99a1af]" /> : <IoChevronDown className="text-lg text-[#99a1af]" />}                      </DisclosureButton>

                      <DisclosurePanel className="border-t border-gray-200 bg-gray-50 space-y-5 px-5 py-5">
                        <div className="bg-white rounded-xl p-4">
                          <p className="text-sm font-semibold text-[#3C3E49] mb-3">Display Name</p>
                          <div className="">
                            <textarea
                              name="display_name"
                              id="display_name"
                              onChange={handleChange}
                              defaultValue={chatbotAppearanceData?.display_name}
                              rows="1"
                              className="px-4 py-3 placeholder:text-sm shadow-box border !border-grey border-[#E7E7E8] rounded-large placeholder:text-[#2B2B2B]/70 outline-[#115B9D] text-sm text-[#2B2B2B] w-full resize-none"
                              placeholder="John"
                              minLength={1}
                            ></textarea>
                          </div>
                        </div>
                        <div className="bg-white rounded-xl p-4">
                          <div className="flex flex-wrap gap-2 items-center mb-4">
                            <label className="text-sm font-semibold text-[#3C3E49]">
                              Initial Messages
                            </label>
                            <div className="flex gap-2">
                              <Checkbox
                                id="apiurlsaveresponse"
                                width={4}
                                height={4}
                                checked={form?.show_initial_message}
                                name="categoryToApply"
                                onChange={(e) => { setForm(prev => ({ ...prev, show_initial_message: e.target.checked })); }}
                              />
                              <p className="text-sm inline-block">Show this message as chat bubble popup</p>
                            </div>
                            
                          </div>
                          <div>
                            <textarea
                              name="initial_message"
                              id="initial_message"
                              onChange={handleChange}
                              defaultValue={chatbotAppearanceData?.initial_message}
                              rows="1"
                              className="px-4 py-3 placeholder:text-sm shadow-box border !border-grey border-[#E7E7E8] rounded-large placeholder:text-[#2B2B2B]/70 outline-[#115B9D] text-sm text-[#2B2B2B] w-full resize-none"
                              placeholder="Hi! What can I help you with?"
                              minLength={1}
                              maxLength={100}
                            ></textarea>
                          </div>
                        </div>
                        <div className="bg-white rounded-xl p-4">
                          <div className="">
                            <div className="flex flex-wrap gap-2 items-center mb-4">
                              <label className="text-sm font-semibold text-[#3C3E49]">
                                Disclaimer Text
                              </label>

                              <div className="flex gap-2">
                                <Checkbox
                                  id="disclamer"
                                  width={4}
                                  height={4}
                                  checked={form?.show_disclaimer}
                                  name="disclamer"
                                  onChange={(e) => { setForm(prev => ({ ...prev, show_disclaimer: e.target.checked })); }}
                                />
                                  <p className="text-sm text-[#3C3E49] inline-block">Show this message at bottom of popup</p>
                              </div>
                            
                            </div>
                            <div>
                              <textarea
                                name="dislaimer"
                                id="dislaimer"
                                onChange={e => setForm(prev => ({ ...prev, disclaimer: e.target.value }))}
                                value={form?.disclaimer}
                                defaultValue={form?.disclaimer}
                                rows="2"
                                className="px-4 py-3 placeholder:text-sm shadow-box border !border-grey border-[#E7E7E8] rounded-large placeholder:text-[#2B2B2B]/70 outline-[#115B9D] text-sm text-[#2B2B2B] w-full resize-none"
                                placeholder="Enter Disclaimer"
                                minLength={1}
                                maxLength={100}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </DisclosurePanel>
                    </div>)}
                  </Disclosure>


                  <Disclosure>
                    {({ open }) => (<div className="border border-gray-200 rounded-2xl overflow-hidden bg-white">
                      <DisclosureButton className="w-full px-5 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors">
                        <div className="flex items-center gap-3">
                          <div className="size-10 rounded-xl bg-[#115B9D17] flex items-center justify-center flex-shrink-0">
                            <LuImage className="text-md text-[#115B9D]" />
                          </div>
                          <div className="text-left">
                            <h3 className="text-gray-900">Branding</h3>
                            <p className="text-sm text-gray-500">Upload logo and icons</p>
                          </div>
                        </div>
                        {open ? <IoChevronUp className="text-md" /> : <IoChevronDown className="text-md" />}
                      </DisclosureButton>
                      <DisclosurePanel className="border-t border-gray-200 bg-gray-50 space-y-5 px-5 py-5">
                        <div className="bg-white rounded-xl p-4">
                          <p className="text-sm font-semibold text-[#3C3E49] mb-4"> Profile Picture</p>
                          <div className="flex gap-3">
                            <img
                              src={methodModel.userImg(chatbotAppearanceData?.chatbot_image)}
                              alt="Profile Picture"
                              ref={chatbotImageRef}
                              className="w-[60px] h-[60px] rounded-xl overflow-hidden border-2 border-gray-200 flex-shrink-0 bg-white"
                            />
                            <div className="flex flex-col gap-2">
                              <div className="flex gap-1 items-center w-fit rounded-xl py-2 px-4 border border-[#E7E7E8] relative overflow-hidden">
                                <FiUpload className="text-lg text-[#2B2B2B]" />
                                <span className="text-sm text-[#2B2B2B] leading-none font-semibold">
                                  Upload image
                                </span>
                                <input
                                  type="file"
                                  name="chatbot_image"
                                  id="chatbot_image"
                                  accept="image/*"
                                  onChange={e=>handleFileChange(e,'chatbot_image')}
                                  className="absolute inset-0 w-full h-full opacity-0"
                                />
                              </div>
                              <span className="text-xs text-[#2B2B2BB2] leading-none font-light">
                                Supports JPG, JPEG, PNG and image files only
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="bg-white rounded-xl p-4">
                          <p className="text-sm font-semibold text-[#3C3E49] mb-4"> Chat Icon</p>
                          <div className="flex gap-3">
                            <img
                              style={{ objectFit: "cover" }}
                              src={methodModel.userImg(chatbotAppearanceData?.chatbot_logo)}
                              alt="Chat Icon"
                              ref={chatbotLogoRef}
                              className="w-[60px] h-[60px] rounded-xl overflow-hidden border-2 border-gray-200 flex-shrink-0 bg-white"
                            />
                            <div className="flex flex-col gap-2">
                              <div className="flex gap-1 items-center w-fit rounded-xl py-2 px-4 border border-[#E7E7E8] relative overflow-hidden">
                                <FiUpload className="text-lg text-[#2B2B2B]" />
                                <span className="text-sm text-[#2B2B2B] leading-none font-semibold">
                                  Upload image
                                </span>
                                <input
                                  type="file"
                                  name="chatbot_logo"
                                  id="chatbot_logo"
                                  accept="image/*"
                                  onChange={e=>handleFileChange(e,'chatbot_logo')}
                                  className="absolute inset-0 w-full h-full opacity-0"
                                />
                              </div>
                              <span className="text-xs text-[#2B2B2BB2] leading-none">
                                Supports JPG, JPEG, PNG and image files only
                              </span>
                            </div>
                          </div>
                        </div>

                      </DisclosurePanel>
                    </div>)}
                  </Disclosure>


                  <Disclosure>
                    {({ open }) => (<div className="border border-gray-200 rounded-2xl overflow-hidden bg-white">
                      <DisclosureButton className="w-full px-5 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors">
                        <div className="flex items-center gap-3">
                          <div className="size-10 rounded-xl bg-[#115B9D17] flex items-center justify-center flex-shrink-0">
                            <IoColorPaletteOutline className="text-md text-[#115B9D]" />
                          </div>
                          <div className="text-left">
                            <h3 className="text-gray-900">Colors & Theme</h3>
                            <p className="text-sm text-gray-500">Customize widget colors</p>
                          </div>
                        </div>
                        {open ? <IoChevronUp className="text-md" /> : <IoChevronDown className="text-md" />}
                      </DisclosureButton>
                      <DisclosurePanel className="border-t border-gray-200 bg-gray-50 space-y-5 px-5 py-5">
                        <div className="bg-white rounded-xl p-4">
                          <p className="text-sm font-semibold text-[#3C3E49] mb-4">Chat Bubble Interface</p>
                          <div className="">
                            <div className="">
                              <div className="">
                                {form?.chat_bubble_show && (
                                  <div
                                    id="bubbles_chats"
                                    style={{ position: "relative", marginTop: "" }}
                                  >
                                              <IoChatbubbleEllipses
                                    width={(form?.bubbleWidth || 60)}
                                    height={(form?.bubbleHeight || 60)}
                                    color={form?.chat_bubble_icon_color || "white"}
                                    style={{width:`${form?.bubbleWidth}px`,height:`${form?.bubbleHeight}px`}}
                                    className={form?.chat_bubble_logo ? 'rounded-full' : ''}
                                  />
                                  </div>
                                )}
                              </div>
                              {form?.chat_bubble_show && (
                                <div className="">
                                  <div className="flex gap-x-3 items-center justify-between py-3 border-b border-gray-100 last:border-0">
                                    <label className="text-sm text-gray-700">
                                      Icon Color
                                    </label>
                                    <div>
                                      <input
                                        type="color"
                                        name="chat_bubble_icon_color"
                                        className="w-10 h-8 border border-[#F4F4F5]"
                                        value={form?.chat_bubble_icon_color}
                                        onChange={(e) =>
                                          setForm((prev) => ({
                                            ...prev,
                                            chat_bubble_icon_color: e.target.value,
                                          }))
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="bg-white rounded-xl p-4">
                          <div className="mb-4">
                            <p className="text-sm font-semibold text-[#3C3E49]">Chat Interface Colors <span className="text-sm font-[300] text-gray-700">( Top Bar )</span></p>
                          </div>
                          <div className="">
                            <div className="flex gap-x-3 items-center justify-between py-3 border-b border-gray-100 last:border-0">
                              <label className="inline-block text-sm">Background</label>
                              <div className="flex items-center gap-2">
                                <p className="text-sm ms-2 w-[80px] uppercase text-right">
                                  {chatbotAppearanceData
                                    ? chatbotAppearanceData.top_bar_background
                                    : ""}
                                </p>
                                <input
                                  type="color"
                                  name="top_bar_background"
                                  className="h-7 w-7"
                                  value={
                                    chatbotAppearanceData
                                      ? chatbotAppearanceData.top_bar_background
                                      : ""
                                  }
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                            <div className="flex gap-x-3 items-center justify-between py-3 border-b border-gray-100 last:border-0">
                              <label className="inline-block text-sm">Textcolor</label>
                              <div className="flex items-center gap-2">
                                <p className="text-sm ms-2 w-[80px] uppercase text-right">
                                  {chatbotAppearanceData
                                    ? chatbotAppearanceData.top_bar_textcolor
                                    : ""}
                                </p>
                                <input
                                  type="color"
                                  name="top_bar_textcolor"
                                  className="h-7 w-7"
                                  value={
                                    chatbotAppearanceData
                                      ? chatbotAppearanceData.top_bar_textcolor
                                      : ""
                                  }
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* <div className="bg-white rounded-xl p-4">
                          <p className="text-sm font-semibold text-[#3C3E49] mb-4"> Inline Chatbot Buttons</p>

                          <div className="">
                            <div className="flex gap-x-3 items-center justify-between py-3 border-b border-gray-100 last:border-0">
                              <label className="inline-block mb-1 text-sm">
                                Text Color
                              </label>
                              <div className="flex items-center gap-2">
                                <span className="text-sm">
                                  {form?.live_button_text_color}
                                </span>
                                <input
                                  type="color"
                                  value={form?.live_button_text_color}
                                  onChange={(e) =>
                                    setForm((prev) => ({
                                      ...prev,
                                      live_button_text_color: e.target.value,
                                    }))
                                  }
                                  className="h-8 w-8 border border-gray-300 rounded"
                                />
                              </div>
                            </div>
                            <div className="flex gap-x-3 items-center justify-between py-3 border-b border-gray-100 last:border-0">
                              <label className="inline-block mb-1 text-sm">
                                Background Color
                              </label>
                              <div className="flex items-center gap-2">
                                <span className="text-sm">
                                  {form?.live_button_background}
                                </span>
                                <input
                                  type="color"
                                  value={form?.live_button_background}
                                  onChange={(e) =>
                                    setForm((prev) => ({
                                      ...prev,
                                      live_button_background: e.target.value,
                                    }))
                                  }
                                  className="h-8 w-8 border border-gray-300 rounded"
                                />
                              </div>
                            </div>
                          </div>
                        </div> */}


                        <div className="bg-white rounded-xl p-4">
                          <p className="text-sm font-semibold text-[#3C3E49] mb-4">Message Window</p>
                          <div className="flex gap-x-3 items-center justify-between py-3 border-b border-gray-100 last:border-0">
                            <label className="inline-block text-sm">Bot Message Background</label>
                            <div className="flex items-center gap-2">
                              <p className="text-sm ms-2 w-[80px] uppercase text-right">
                                {chatbotAppearanceData
                                  ? chatbotAppearanceData.bot_message_background
                                  : ""}
                              </p>
                              <input
                                type="color"
                                name="bot_message_background"
                                className="h-7 w-7"
                                value={
                                  chatbotAppearanceData
                                    ? chatbotAppearanceData.bot_message_background
                                    : ""
                                }
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div className="flex gap-x-3 items-center justify-between py-3 border-b border-gray-100 last:border-0">
                            <label className="inline-block text-sm">Bot Message Color</label>
                            <div className="flex items-center gap-2">
                              <p className="text-sm ms-2 w-[80px] uppercase text-right">
                                {chatbotAppearanceData
                                  ? chatbotAppearanceData.bot_message_color
                                  : ""}
                              </p>
                              <input
                                type="color"
                                name="bot_message_color"
                                className="h-7 w-7"
                                value={
                                  chatbotAppearanceData
                                    ? chatbotAppearanceData.bot_message_color
                                    : ""
                                }
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="bg-white rounded-xl p-4">
                          <p className="text-sm font-semibold text-[#3C3E49] mb-4">User Message</p>
                          <div className="flex gap-x-3 items-center justify-between py-3 border-b border-gray-100 last:border-0">
                            <label className="inline-block text-sm">Background</label>
                            <div className="flex items-center gap-2">
                              <p className="text-sm ms-2 w-[80px] uppercase text-right">
                                {chatbotAppearanceData
                                  ? chatbotAppearanceData.user_message_background
                                  : ""}
                              </p>
                              <input
                                type="color"
                                name="user_message_background"
                                className="h-7 w-7"
                                value={
                                  chatbotAppearanceData
                                    ? chatbotAppearanceData.user_message_background
                                    : ""
                                }
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div className="flex gap-x-3 items-center justify-between py-3 border-b border-gray-100 last:border-0">
                            <label className="inline-block text-sm">Color</label>
                            <div className="flex items-center gap-2">
                              <p className="text-sm ms-2 w-[80px] uppercase text-right">
                                {chatbotAppearanceData?.user_message_color
                                  ? chatbotAppearanceData.user_message_color
                                  : "#6956e5"}
                              </p>
                              <input
                                type="color"
                                name="user_message_color"
                                className="h-7 w-7"
                                value={
                                  chatbotAppearanceData?.user_message_color
                                    ? chatbotAppearanceData.user_message_color
                                    : "#6956e5"
                                }
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="bg-white rounded-xl p-4">
                          <p className="text-sm font-semibold text-[#3C3E49] mb-4">Chat Window</p>
                          <div className="flex gap-x-3 items-center justify-between py-3 border-b border-gray-100 last:border-0">
                            <label className="inline-block text-sm">Background</label>
                            <div className="flex gap-x-3 items-center justify-between py-3 border-b border-gray-100 last:border-0">
                              <p className="text-sm ms-2 w-[80px] uppercase text-right">
                                {chatbotAppearanceData
                                  ? chatbotAppearanceData.chatbot_background_color
                                  : ""}
                              </p>
                              <input
                                type="color"
                                name="chatbot_background_color"
                                className="h-7 w-7"
                                value={
                                  chatbotAppearanceData
                                    ? chatbotAppearanceData.chatbot_background_color
                                    : ""
                                }
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div className="flex gap-x-3 items-center justify-between py-3 border-b border-gray-100 last:border-0">
                            <label className="inline-block text-sm">Border</label>
                            <div className="flex items-center gap-2">
                              <p className="text-sm ms-2 w-[80px] uppercase text-right">
                                {form?.chatbotBorderColor || "#000000"}
                              </p>
                              <input
                                type="color"
                                value={form?.chatbotBorderColor}
                                className="h-7 w-7"
                                onChange={(e) =>
                                  setForm({
                                    ...form,
                                    chatbotBorderColor: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="flex gap-x-3 items-center justify-between py-3 border-b border-gray-100 last:border-0">
                            <label className="inline-block text-sm">Send Button</label>
                            <div className="flex items-center gap-2">
                              <p className="text-sm ms-2 w-[80px] uppercase text-right">
                                {form?.sendBtnBg || "#000000"}
                              </p>
                              <input
                                type="color"
                                value={form?.sendBtnBg}
                                className="h-7 w-7"
                                onChange={(e) =>
                                  setForm({ ...form, sendBtnBg: e.target.value })
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </DisclosurePanel>
                    </div>)}
                  </Disclosure>
                  <div className="flex justify-end mt-5">
                    {urlAllow("editchatbot") && (
                      <button
                        type="submit"
                        className="!px-5 text-sm font-normal hover:text-white hover:no-underline text-[#115B9D] h-10 flex items-center justify-center gap-2 hover:bg-[#115B9D] rounded-extra_large shadow-btn border border-[#115B9D] transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed"
                      >
                        Save
                      </button>
                    )}
                  </div>
                </form>

              </div>
              <div className="col-span-12 lg:col-span-5 xl:col-span-5">
                <div className="bg-white rounded-2xl shadow-sm border border-gray-200 px-5 py-4 mb-5">
                  <div className="flex items-center gap-2 mb-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-eye size-5 text-[#115B9D]" data-fg-b4p6234="3.264:4.52549:/src/app/components/WidgetTab.tsx:510:15:23262:41:e:Eye::::::fTU"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path><circle cx="12" cy="12" r="3"></circle></svg>
                    <h3 className="text-gray-900">Live Preview</h3>
                  </div>
                  <p className="text-sm text-gray-600">Changes apply in real-time</p>
                </div>
                <div>
                  <div
                    className={`bg-white rounded-2xl md:rounded-3xl shadow-2xl overflow-hidden animate-in slide-in-from-bottom-4 duration-300 h-full md:h-auto`}
                    style={{border:`1px solid ${form?.chatbotBorderColor}`}}
                  >
                    <div>
                      <div
                        className="bg-white px-5 py-4 flex items-center justify-between border-b border-slate-100"
                      style={{
                        backgroundColor: chatbotAppearanceData
                          ? chatbotAppearanceData.top_bar_background
                          : "#ffffff",
                      }}
                      >
                        <div className="flex items-center gap-2 text-sm">
                          <img
                            src={methodModel.userImg(chatbotAppearanceData?.chatbot_image)}
                            id="chatImageHeader"
                            ref={chatbotImageViewRef}
                            alt=""
                            className="object-cover w-12 h-12 rounded-full"
                          />
                          <p
                            className="font-medium text-slate-900 "
                          style={{
                            color: chatbotAppearanceData
                              ? chatbotAppearanceData.top_bar_textcolor
                              : "#000",
                          }}
                          >
                            {chatbotAppearanceData
                              ? chatbotAppearanceData.display_name
                              : "John"}
                          </p>
                        </div>
                        <div className="flex items-center gap-2">
                          {form?.showHeader && (
                            <img
                              src={
                               methodModel.userImg(form.logo)
                                   
                              }
                              id="chatImageHeader"
                              alt=""
                              className="object-contain h-10 2xl:h-12"
                            />
                          )}
                          <button
                            type="button"
                            className="flex items-center justify-center w-7 h-7 group rounded-large"
                          >
                            <FiX className="text-[#2B2B2B] text-xl group-hover:text-[#115B9D]" />
                          </button>
                        </div>
                      </div>
                      <div className="h-[calc(100vh-180px)] md:h-[480px] overflow-y-auto ">
                        <div
                          className="p-5 !pb-1 h-full overflow-auto"
                      style={{backgroundColor:chatbotAppearanceData?.chatbot_background_color}}
                        >
                          <>
                  
                              <>
                                <div className="flex justify-start mb-2 items-start gap-2.5 flex-col">
                               
                                  <div className="relative flex items-start justify-start gap-2.5 pr-4">
                                    <img
                                      src={methodModel.userImg(chatbotAppearanceData?.chatbot_logo)}
                                      alt=""
                                      ref={chatbotLogoViewRef}
                                      className="w-8 h-8 rounded-full shrink-0"
                                    />
                                    <div className="flex flex-col">
                                      <p
                                        className={`rounded-[6px] text-white text-sm  bg-[#115B9D] px-4 py-3`}
                                        style={{
                                          backgroundColor: chatbotAppearanceData
                                            ? chatbotAppearanceData.bot_message_background
                                            : "#ffffff",
                                          color: chatbotAppearanceData
                                            ? chatbotAppearanceData.bot_message_color
                                            : "#878787",
                                        }}
                                      >
                                        {chatbotAppearanceData?.initial_message
                                          ? chatbotAppearanceData.initial_message
                                          : "Hi there! 👋 Looking for something or need help? I’m here to make things easy — just ask!"}
                                      </p>
                                    </div>
                                    <div className="relative hidden mt-auto">
                                      <FaThumbsDown
                                        className="size-4 !text-[#705EE6] cursor-pointer"
                                        style={{
                                          transform: "rotateY(180deg)",
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="flex flex-col items-end justify-end gap-2.5 mb-2">
                                  <div className="flex items-start justify-end gap-2.5 pr-4">
                                    <p
                                      className={`bg-[#F1F1F0] rounded-[6px] px-4 py-3 text-sm leading-none text-[#2B2B2B] tracking-[0.2px]`}
                                      style={{
                                        backgroundColor: chatbotAppearanceData
                                          ? chatbotAppearanceData.user_message_background
                                          : "#ffffff",
                                        color: chatbotAppearanceData
                                          ? chatbotAppearanceData.user_message_color
                                          : "#878787",
                                      }}
                                    >
                                      Hi There
                                    </p>
                                  </div>
                                </div>
                              </>
                          </>
                        </div>
                      </div>
                      {SelectedPlatform ? <div className="px-5 py-2 border-t border-[#EAECF0] flex gap-3">
                        <input
                          type="text"
                          name=""
                          id=""
                          className="placeholder:font-light w-full h-11 shadow-box border !border-grey py-2.5 px-3.5 rounded-large text-sm leading-6 text-gray-900 focus:outline-[#115B9D]"
                          placeholder="Message......"
                        />
                        <button
                          type="button"
                          style={{
                            backgroundColor: form?.sendBtnBg || "#115B9D",
                          }}
                          className="flex items-center justify-center w-11 h-11 shrink-0 hover:opacity-80 rounded-extra_large"
                        >
                          <img
                            src="/assets/img/svgs/send.svg"
                            alt=""
                            className="w-5 h-5"
                          />
                        </button>
                      </div> : null}
                      {form?.show_disclaimer ? <div className="px-5 py-4 bg-slate-50 border-t border-slate-100" >
                        <p className="text-xs text-center text-slate-500">
                          {form?.disclaimer}
                        </p>
                      </div> : null}
                    </div>
                  </div>
                </div>
                <div className={`text-${form.position || "left"} mt-2`}>
                  <div
                    className={`dazh-iconBtn dazh-${form.buttonStyle || "regular"} dazh-${form.size || "small"} dazh-${form.position || "left"}`}
                    title={`${form.label || "IKnow"}`}
                    style={{
                      marginLeft:
                        form.position == "right"
                          ? `initial`
                          : `${form.xAxis}px`,
                      marginRight:
                        form.position == "right"
                          ? `${form.xAxis}px`
                          : `initial`,
                      marginBottom: `${form.yAxis}px`,
                      color:
                        form.buttonStyle == "no-background"
                          ? `${form.colorTheme}`
                          : `#ffffff`,
                      borderRadius: `${form.radius}%`,
                    }}
                  >
                    <div>
                      <div className="dazh-flex min-h-24">
                        {form?.chat_bubble_show ? (
                          <div
                            id="bubbles_chats"
                            style={{ position: "relative", marginTop: "15px" }}
                          >
                            
                                  <IoChatbubbleEllipses
                                    width={(form?.bubbleWidth || 60)}
                                    height={(form?.bubbleHeight || 60)}
                                    color={form?.chat_bubble_icon_color || "white"}
                                    style={{width:`${form?.bubbleWidth}px`,height:`${form?.bubbleHeight}px`}}
                                    className={form?.chat_bubble_logo ? 'rounded-full' : ''}
                                  />
                          </div>
                        ) : (
                          <img
                            src={`${  methodModel.userImg(form?.logo)
                              }`}
                            style={{
                              height: `${form.iconSize}px`,
                              width: `${form.iconSize}px`,
                            }}
                            className="object-contain w-full h-full px-1"
                          />
                        )}
                        <div>
                          <div className="dazh-btn-title">{form.title}</div>
                          <div className="dazh-btn-description">{form.description}</div>
                        </div>
                      </div>
                      <span className="dazh-btn-text">{form.iconText}</span>
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-5 space-y-4">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-gray-900">Script</h3>
                    <button
                      onClick={(e) => {
                        copyScript();
                        onSubmit(e);
                        handleChatbotSubmit(e, "copy");
                      }}
                      className="px-4 py-2 rounded-xl text-sm transition-all flex items-center gap-2 bg-gray-50 text-gray-700 border border-gray-300 hover:bg-gray-100"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-copy size-4" data-fg-b4p6298="3.264:4.52549:/src/app/components/WidgetTab.tsx:655:21:29529:27:e:Copy::::::CwVW"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path></svg>
                      {IsCopied ? "Copied" : "Copy"}
                    </button>
                  </div>
                  <textarea
                    className="bg-gray-50 min-h-[300px] overflow-hidden border border-gray-300 text-gray-900 text-sm rounded-large focus:ring-blue-500 focus:border-[#115B9D] block w-full p-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-300 dark:text-white dark:focus:ring-blue-500 dark:focus:border-[#115B9D]"
                    disabled
                    value={script}
                  />

                </div>
                {IsCopied && (
                  <span
                    className="inline-block p-2 mt-3 ml-3 text-xs bg-[#115B9D]/10 rounded-large text-[#115B9D] w-fit"
                    style={{ float: "right" }}
                  >
                    Script copied to clipboard!
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </Layout> */}
    </>
  );
};

export default Widget; 